import React, { useContext, useEffect, useRef, useState } from 'react';
import '../less/App.less';
import {
  Footer,
  Header,
  RemoteClient,
  TermsConditions,
  useUserinfo,
} from '@mss/mss-component-library';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import HomePage from './status';
import { useTranslation } from 'react-i18next';
import Authorization from './authorization';
import ActivityLog from './activity-log';
import FileTransfer from './file-transfer';
import Sessions from './sessions';
import Configuration from './configuration';
import ReleaseNotes from './release-notes';
import RemoteAccess from './remote-access';
import { routes } from './common/constants';
import Navbar from './common/Navbar';
import QuestionDrawer from './common/QuestionDrawer';
import Profile from './profile';
import { AppContext } from './index';
import Api from './authorization/services/Api';
import FieldAssetList from './asset/views/FieldAsset/List';
import AssetPage from './common/AssetPages';

const MainRouting = () => {
  return (
    <Switch>
      <Route path={`/${routes.STATUS}`} component={HomePage} />
      <Route
        path={`/${routes.ASSETS}/field`}
        exact
        component={FieldAssetList}
      />
      <Route
        path={`/:category(assets|applications)/:assetType`}
        component={AssetPage}
      />
      <Route path={`/${routes.AUTH}`} component={Authorization} />
      <Route path={`/${routes.ACTIVITY_LOG}`} component={ActivityLog} />
      <Route path={`/${routes.FILE_TRANSFER}`} component={FileTransfer} />
      <Route path={`/${routes.SESSIONS}`} component={Sessions} />
      <Route path={`/${routes.CONFIG}`} component={Configuration} />
      <Route path={`/${routes.RELEASE_NOTES}`} component={ReleaseNotes} />
      <Route path={`/${routes.REMOTE_ACCESS}`} component={RemoteAccess} />
      <Route path={`/${routes.PROFILE}`} component={Profile} />
      <Route
        path={'/'}
        exact
        render={() => <Redirect to={`/${routes.STATUS}`} />}
      />
      <Route render={() => <h1>404 - Not found</h1>} />
    </Switch>
  );
};

const App = () => {
  const [, , user] = useUserinfo();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const inline = params.get('inline');
  const isInline = useRef(inline === 'true');
  const { mssVersions } = useContext(AppContext);
  const { siteName, customerLogo } = useContext(AppContext);

  useEffect(() => {
    isInline.current = inline === 'true';
  }, [inline]);

  if (user?.show_terms)
    return (
      <TermsConditions
        variant="site"
        logout={() => {
          Api.user.logout();
        }}
      />
    );
  return (
    <div className="min-h-screen flex flex-col">
      {(!isInline.current && (
        <>
          <Header
            logout={Api.user.logout}
            siteName={siteName}
            customerLogo={customerLogo}
            user={user!}
            onInfoClick={() => setIsDrawerVisible(!isDrawerVisible)}
            title="SITE MANAGER"
          />
          <Navbar />
          <QuestionDrawer
            isDrawerVisible={isDrawerVisible}
            handleClose={() => setIsDrawerVisible(false)}
          />
        </>
      )) ||
        null}
      <div className="mb-4 flex-auto">
        <MainRouting />
      </div>
      <Footer version={mssVersions?.mss_site_api} />
    </div>
  );
};

const I18n = () => {
  const [, , user] = useUserinfo();
  const { i18n } = useTranslation();
  const lng = user?.language;
  useEffect(() => {
    if (lng) {
      const changeLng = async () => {
        await i18n.changeLanguage(lng);
      };
      changeLng();
    }
  }, [lng]);

  return (
    <Switch>
      <Route
        path={`/${routes.REMOTE_ACCESS}/client/:sessionId`}
        exact
        render={() => <RemoteClient component="site" port={'8002'} />}
      />
      <Route component={App} />
    </Switch>
  );
};

export default I18n;
